import { render, staticRenderFns } from "./BrowseSortBox.vue?vue&type=template&id=50537a80&scoped=true&"
import script from "./BrowseSortBox.vue?vue&type=script&lang=js&"
export * from "./BrowseSortBox.vue?vue&type=script&lang=js&"
import style0 from "./BrowseSortBox.vue?vue&type=style&index=0&id=50537a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50537a80",
  null
  
)

export default component.exports